import { apiClient } from './apiClient'
import { RankingPointsDTO } from '../types/dtos'

export interface UpdateExclusionRequest {
  isExcluded: boolean
  exclusionReason?: string
}

class RankingPointsService {
  /**
   * Get all ranking points for a player in a ranking series
   */
  async getPlayerPoints(userId: number, rankingSeriesId: number): Promise<RankingPointsDTO[]> {
    const response = await apiClient.get<RankingPointsDTO[]>(
      `/ranking/points/player/${userId}/series/${rankingSeriesId}`
    )
    return response.data
  }

  /**
   * Get all ranking points for an external player in a ranking series
   */
  async getExternalPlayerPoints(externalPlayerId: string, rankingSeriesId: number): Promise<RankingPointsDTO[]> {
    const response = await apiClient.get<RankingPointsDTO[]>(
      `/ranking/points/external-player/${externalPlayerId}/series/${rankingSeriesId}`
    )
    return response.data
  }

  /**
   * Get ranking points for a standing — dispatches to the correct endpoint based on whether
   * the standing belongs to a registered user or an external player.
   */
  async getStandingPoints(
    standing: { userId: number | null; externalPlayerId?: string | null },
    seriesId: number
  ): Promise<RankingPointsDTO[]> {
    if (standing.userId) {
      return this.getPlayerPoints(standing.userId, seriesId)
    } else if (standing.externalPlayerId) {
      return this.getExternalPlayerPoints(standing.externalPlayerId, seriesId)
    }
    return []
  }

  /**
   * Update exclusion status for a ranking points record
   */
  async updateExclusion(rankingPointsId: number, request: UpdateExclusionRequest): Promise<void> {
    await apiClient.put(`/ranking/points/${rankingPointsId}/exclusion`, request)
  }
}

export const rankingPointsService = new RankingPointsService()
